import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { BONUSES } from '../data/content';
export function Bonuses() {
  return <section className="bg-teal-50 py-14" data-id="element-25" data-mp="av370wfflb2q">
      <div className="mx-auto max-w-page px-5" data-id="element-26" data-mp="au1x4va5iuml">
        <SectionHeading eyebrow="Incluidos hoy" title="3 Bonos estratégicos" subtitle="No son relleno: son las tres cosas que hacen que el protocolo se sostenga cuando llega la semana difícil." data-id="element-27" data-mp="at8ti36hol8o" />

        <ul className="mt-9 flex flex-col gap-4" data-id="element-28" data-mp="1wrh6wme2hbc">
          {BONUSES.map(bonus => <li key={bonus.number} className="relative rounded-2xl border border-line bg-paper p-5 pr-5 shadow-card" data-id="element-29" data-mp="5xjpnnnfsi6k">
              <div className="flex items-start justify-between gap-4" data-id="element-30" data-mp="3o3pp5q9xpern">
                <div className="flex items-start gap-3" data-id="element-31" data-mp="3t182rtywci5z">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-flame-soft" data-id="element-32" data-mp="1m9qi5h3uhjkr">
                    <GiftIcon className="h-4 w-4 text-flame" aria-hidden="true" data-id="element-33" data-mp="1r9lalp39qh7x" />
                  </span>
                  <div data-id="element-34" data-mp="3idel6385ly3t">
                    <p className="text-[10.5px] font-extrabold uppercase tracking-[0.16em] text-flame" data-id="element-35" data-mp="3icvan7ku2bzt">
                      {bonus.number}
                    </p>
                    <h3 className="mt-0.5 font-display text-[18px] font-black leading-tight text-night" data-id="element-36" data-mp="3r700pos57jea">
                      {bonus.title}
                    </h3>
                  </div>
                </div>
                <div className="shrink-0 text-right" data-id="element-37" data-mp="2zglp5z7lqj5s">
                  <p className="text-[13px] font-semibold text-muted line-through" data-id="element-38" data-mp="2ugh92aalvqg3">{bonus.price}</p>
                  <p className="font-display text-[15px] font-black uppercase text-flame" data-id="element-39" data-mp="38g8tasrpu32j">Gratis</p>
                </div>
              </div>
              <p className="mt-3 text-[14px] leading-relaxed text-muted" data-id="element-40" data-mp="33g4b8yb5t0a7">{bonus.description}</p>
            </li>)}
        </ul>

        <p className="mt-6 rounded-2xl bg-night px-5 py-4 text-center font-display text-[17px] font-black leading-snug text-canvas sm:text-[20px]" data-id="element-41" data-mp="nogizg73bvxq">
          Valor total bonos: <span className="text-canvas/50 line-through" data-id="element-42" data-mp="3cjpsvc949iuf">$33.000</span>{' '}
          <span className="text-amber" data-id="element-43" data-mp="3hhr9lqj2l62q">→ GRATIS</span> con tu Protocolo
        </p>
      </div>
    </section>;
}